import { Environment } from "Constants/constants";

interface FeatureToggle {
  prod: boolean;
  test: boolean;
}

export const isDevelopmentEnv = (): boolean =>
  window.env.ENVIRONMENT === Environment.DEVELOPMENT;

export const isTestOrDevelopmentEnv = (): boolean =>
  isDevelopmentEnv() ||
  window.env.ENVIRONMENT === Environment.CLIENT_T ||
  window.env.ENVIRONMENT === Environment.CLIENT_TS;

export const isProductionEnv = (): boolean =>
  window.env.ENVIRONMENT === Environment.PRODUCTION;

export const featureToggle = (feature: FeatureToggle): boolean =>
  (isTestOrDevelopmentEnv() && feature.test) ||
  (isProductionEnv() && feature.prod);
